import { PropertyType } from '../../../common';

export const mapApiToEntity = (data: PropertyType): PropertyType => ({
	campaigns: data.data,
	pagesTotal: data.pagination.total_pages,
});

export const mapEntityToApi = (data: PropertyType): PropertyType => ({
	sid: data.token,
	page: data.page,
});
